import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var ExposedPromiseStatus;

(function (ExposedPromiseStatus) {
  ExposedPromiseStatus["PENDING"] = "pending";
  ExposedPromiseStatus["RESOLVED"] = "resolved";
  ExposedPromiseStatus["REJECTED"] = "rejected";
})(ExposedPromiseStatus || (ExposedPromiseStatus = {}));

var notInitialized = function notInitialized() {
  throw new Error('ExposedPromise not initialized yet.');
};
/**
 * Exposed promise allow you to create a promise and then resolve it later, from the outside
 */


export var ExposedPromise = /*#__PURE__*/function () {
  function ExposedPromise() {
    var _this = this;

    _classCallCheck(this, ExposedPromise);

    this._resolve = notInitialized;
    this._reject = notInitialized;
    this._status = ExposedPromiseStatus.PENDING;
    this._promise = new Promise(function (innerResolve, innerReject) {
      _this._resolve = function (value) {
        if (_this.isSettled()) {
          return;
        }

        _this._promiseResult = value;
        innerResolve(value);
        _this._status = ExposedPromiseStatus.RESOLVED;
        return;
      };

      _this._reject = function (reason) {
        if (_this.isSettled()) {
          return;
        }

        _this._promiseError = reason;
        innerReject(reason);
        _this._status = ExposedPromiseStatus.REJECTED;
        return;
      };
    });
  }

  _createClass(ExposedPromise, [{
    key: "promise",
    get: function get() {
      return this._promise;
    }
  }, {
    key: "resolve",
    get: function get() {
      return this._resolve;
    }
  }, {
    key: "reject",
    get: function get() {
      return this._reject;
    }
  }, {
    key: "status",
    get: function get() {
      return this._status;
    }
  }, {
    key: "promiseResult",
    get: function get() {
      return this._promiseResult;
    }
  }, {
    key: "promiseError",
    get: function get() {
      return this._promiseError;
    }
  }, {
    key: "isPending",
    value: function isPending() {
      return this.status === ExposedPromiseStatus.PENDING;
    }
  }, {
    key: "isResolved",
    value: function isResolved() {
      return this.status === ExposedPromiseStatus.RESOLVED;
    }
  }, {
    key: "isRejected",
    value: function isRejected() {
      return this.status === ExposedPromiseStatus.REJECTED;
    }
  }, {
    key: "isSettled",
    value: function isSettled() {
      return this.isResolved() || this.isRejected();
    }
  }], [{
    key: "resolve",
    value: function resolve(value) {
      var promise = new ExposedPromise();
      promise.resolve(value);
      return promise;
    }
  }, {
    key: "reject",
    value: function reject(reason) {
      var promise = new ExposedPromise();
      promise.reject(reason);
      return promise;
    }
  }]);

  return ExposedPromise;
}();